import { createNode, DurationDataType } from '@glueapp/graph-types';
import { Temporal } from '@js-temporal/polyfill';
import { fromDuration } from '../../utils/temporal';

export const ParseDuration = createNode({
    id: 'Parse Duration',
    name: 'Parse Duration',
    description: 'Parses a Duration from an ISO 8601 string (e.g. "P1Y2M3DT4H5M6S")',
    aiDescription:
        'Takes an ISO 8601 duration string (e.g. "P1Y2M3DT4H5M6S") on the "Text" port and outputs a parsed Duration on the "Duration" port.',
    category: 'Date & Time',
    color: '#3b82f6',
    integration: undefined,
    inPorts: {
        Text: { kind: 'string' },
    },
    outPorts: {
        Duration: DurationDataType,
    },
    execute: function (input) {
        const duration = Temporal.Duration.from(input.inPorts.Text);
        return { output: { Duration: fromDuration(duration) } };
    },
});
